module.exports = __webpack_public_path__ + "img/building.3fd83337.svg";